import http from "../../http-common";
import http_multipart from "@/http-multipart";

class OperationPackage {
    /**
     * Lấy danh sách gói
     * @param status
     * */
    getListPackageTuition(status) {
        return http.get(`/listPackage/search?status=${status}`)
    }

    /**
     * Xoá gói
     * @param id
     * @param status
     * */
    deletePackages(id, status) {
        return http.delete(`listPackage?id=${id}&status=${status}`)
    }

    filterPackageTuition(data, pagination) {
        let startDate = "";
        let endDate = "";
        let managerTuitionStatus = data.ManagerTuitionStatus;
        if (!managerTuitionStatus) {
            managerTuitionStatus = "all";
        }

        if (data.rangeMonth.length > 1) {
            startDate = data.rangeMonth[0].toString();
            endDate = data.rangeMonth[1].toString();
        }

        if (data.idGrade === undefined) {
            data.idGrade = "";
        }

        if (data.idClass === undefined) {
            data.idClass = "";
        }
        return http.get(
            `/managerTuition/find/filter?kidStatus=${data.kidStatus}&idGrade=${data.idGrade}&idClass=${data.idClass}&ManagerTuitionStatus=${managerTuitionStatus}&specialNameTelephone=${data.specialNameTelephone}&idPackageTuition=${data.idPackageTuition}&remainDay=${data.remainDay}&startDate=${startDate}&endDate=${endDate}&page=${pagination.page}&limit=${pagination.limit}&status=${data.status}`
        )
    }

    savePackage(data) {
        return http.post(`/listPackage`, data);
    }

    updatePackage(data) {
        return http.put(`/listPackage`, data);
    }

//     Gửi thông báo tùy chỉnh
    submitCustomContent(formData){
        return http_multipart.post(`/managerTuition/sendFirebaseCustom`, formData);
    }

//     Lấy gửi thông tin mặc định
    getTextSample(){
        return http.get(`/managerTuition/textSample`);
    }

//     Gửi thông báo mặc định
    submitDefaultContent(data){
        return http.post(`/managerTuition/sendFirebaseDefault`,data);
    }

    sendSms(data) {
        return http.post(`/managerTuition/sendSMS`, data);
    }

    extendPackage(data) {
        return http.put(`/managerTuition/extend`, data);
    }

    subscribesPackage(data) {
        return http.put(`/managerTuition/extend/list`, data);
    }

    checkShowForApp(data) {
        return http.post(`/fn/fees/orderKidsExcel/displayListOrderForApp`, data);
    }
}

export default new OperationPackage();